import gsap from 'gsap'
import { textFilterAnimation } from './utilities'
import { GSDevTools } from 'gsap/GSDevTools'

gsap.registerPlugin(GSDevTools)

export const initPreloader = () => {
	
	const preloader = document.querySelector('.preloader')
	const preloaderShown = localStorage.getItem('preloader')

	if (!preloader) return

	// if (preloaderShown) {
	// 	preloader.remove()
	// 	return
	// }

	const preloaderDoorLeft = document.querySelector('.preloader__door-left')
	const preloaderDoorRight = document.querySelector('.preloader__door-right')
	const preloaderIllustrations = document.querySelectorAll('.preloader__illustrations')

	const timeline = gsap.timeline({
		delay: 0.25,
		onComplete: () => {
			preloader.remove()
			localStorage.setItem('preloader', 'true')
		}
	})

	timeline.to(preloaderDoorLeft, {
		duration: 1.2,
		transformOrigin: 'left',
		rotateY: -125,
		ease: 'power3.inOut',
	})

	timeline.to(preloaderDoorRight, {
		duration: 1.2,
		transformOrigin: 'right',
		rotateY: 125,
		ease: 'power3.inOut',
	}, '<')
 
	timeline.to(preloader, {
		duration: 1.2,
		scale: 9.5,
		force3D: true,
		ease: 'power3.inOut',
		willChange: 'transform',
	}, '+=0.5')

	timeline.to(preloaderIllustrations, {
		duration: 2.8,
		scale: 14,
		force3D: true,
		ease: 'power3.inOut',
		willChange: 'transform',
	}, '<')

	const banner = document.querySelector('.banner')

	if (!banner) return

	const bannerHeading = banner.querySelector('.banner__heading')
	const bannerText = banner.querySelector('.banner__text')
	const bannerButton = banner.querySelector('.banner__button')
	const bannerVideo = banner.querySelector('.banner__video')
	const bannerAnimation = textFilterAnimation(bannerHeading)
	const bannerTextAnimation = textFilterAnimation(bannerText)
	const bannerButtonAnimation = textFilterAnimation(bannerButton)

	timeline.from(bannerVideo, {
		duration: 4,
		scale: 2,
		ease: 'power1.out',
		willChange: 'transform',
	}, 1.2)

	timeline.add(() => {
		bannerAnimation.play()
		bannerTextAnimation.play()
		bannerButtonAnimation.play()
	}, 1.8)

	// GSDevTools.create({ animation: timeline })

}

export default () => {}